<template>
  <div class="table table-small">
    
    <div class="table-header profile">
      <div class="row" :class="{'coparents': coparentsProp, 'children': childrenProp}">
        <span class="column">
          <span> {{ $lang.messages.name }} </span>
        </span>
        <span
          v-if="coparentsProp"
          class="column large-column"
        >
          <span> {{ $lang.messages.email }} </span>
        </span>
        <span
          v-if="childrenProp"
          class="column"
        >
          <span> {{ $lang.messages.coparentsName }} </span>
        </span>
        <span
          v-if="childrenProp"
          class="column">
          <span> {{ $lang.messages.dateOfBirth }} </span>
        </span>
        <span
          v-if="coparentsProp"
          class="column short-column"
        >
          <span> {{ $lang.messages.type }} </span>
        </span>
        <span
          v-if="coparentsProp"
          class="column middle-column"
        >
          <span> {{ $lang.messages.invitationStatus }} </span>
        </span>
        <span
          v-if="coparentsProp"
          class="column middle-column"
        >
          <span> {{ $lang.messages.eligibleToReceiveFunds }} </span>
        </span>
        <span class="column short-column actions">
          <span> {{ $lang.messages.actions }} </span>
        </span>
      </div>
    </div>
    
    <div class="table-body">
      
      <div
        v-if="mockData && coparentsProp"
        class="row coparents mock-row"
      >
        {{ $lang.messages.noCoparentData }}
      </div>
      <div
        v-if="mockData && childrenProp"
        class="row children mock-row"
      >
        {{ $lang.messages.noChildrenData }}
      </div>
      
      <section v-if="list.length !== 0">
        <div
          v-for="(item, indexUserProfile) in list"
          :key="indexUserProfile"
          class="row"
          :class="{'coparents': coparentsProp, 'children': childrenProp}"
        >
          <div class="column-pair">
            <span
              class="column right-padding"
              v-if="coparentsProp || childrenProp"
            >
              <div class="column-name"> {{ $lang.messages.name }} </div>
              <span
                v-if="item.name !== ''"
                class="column-data"
                :title="item.firstName + ' ' + item.lastName"
              >
                {{ item.firstName }} {{ item.lastName }}
              </span>
              <span
                v-if="item.name === ''"
                class="column-data"
              >
                -
              </span>
            </span>
          </div>

          <div
            class="column-pair"
            v-if="coparentsProp"
          >
            <span
              class="column right-padding"
            >
              <div class="column-name"> {{ $lang.messages.email }} </div>
              <span
                v-if="item.email !== ''"
                class="column-data"
                :title="item.email"
              >
                {{ item.email }}
              </span>
              <span
                v-if="item.email === null"
                class="column-data"
              >
                -
              </span>
            </span>
            
            <span
              class="column right-padding"
            >
              <div class="column-name"> {{ $lang.messages.type }} </div>
              <span
                v-if="item.coparentType != null"
                class="column-data capitalize"
                :title="item.coparentType"
              >
                {{ item.coparentType.toLowerCase() }}
              </span>
              <span
                v-if="item.coparentType === null"
                class="column-data"
              >
                -
              </span>
            </span>
          </div>
  
          <div class="column-pair" v-if="coparentsProp">
            <span class="column right-padding">
              <div class="column-name"> {{ $lang.messages.invitationStatus }} </div>
              <span
                v-if="item.invitationStatus !== ''"
                class="column-data"
                :title="$lang.messages[item.invitationStatus]"
              >
                {{ $lang.messages[item.invitationStatus] }}
              </span>
              <span
                v-if="item.invitationStatus === null"
                class="column-data"
              >
                -
              </span>
            </span>
      
            <span class="column center">
              <div class="column-name"> {{ $lang.messages.eligibleToReceiveFunds }} </div>
              <span
                class="column-data"
                :title="item.eligibleToReceiveFunds ? (item.paymentMethod === 'ACH' ? $lang.messages.achDescription : $lang.messages.digitalCheckDescription) : $lang.messages.notEligableDescription"
              >
                <img
                  v-show="item.eligibleToReceiveFunds"
                  src="@/assets/images/reg_checkmark_current.png"
                />
                <img
                  v-show="!item.eligibleToReceiveFunds"
                  src="@/assets/images/close_red_ico.png"
                />
              </span>
            </span>
          </div>
          
          <div
            v-if="childrenProp"
            class="column-pair"
          >
            <span class="column right-padding">
              <div class="column-name"> {{ $lang.messages.coparentsName }} </div>
              <span class="column-data" :title="item.coparentName"> {{ item.coparentName }} </span>
            </span>
  
            <span class="column right-padding">
              <div class="column-name"> {{ $lang.messages.dateOfBirth }} </div>
              <span class="column-data" :title="dateFormat(item.birthDate)"> {{ dateFormat(item.birthDate) }} </span>
            </span>
          </div>

          <span class="column short-column actions-ico" @click="toggleActions(item.guid)" >
            <img
              v-show="childrenProp || (coparentsProp && !(item.coparentType.toLowerCase() === 'duo' && item.invitationStatus === 'INVITATION_ACCEPTED'))"
              src="@/assets/images/payments/actions_ico.png"
            />
  
            <div
              v-if="childrenProp || (coparentsProp && !(item.coparentType.toLowerCase() === 'duo' && item.invitationStatus === 'INVITATION_ACCEPTED'))"
              id="actions-ico"
              class="action-menu"
              :class="[ actionsRowId === item.guid && actions ? 'select-menu-collapsed' : 'select-menu-not-collapsed' ]"
            >
              <div>
                <button
                    v-if="coparentsProp && item.coparentType.toLowerCase() === 'solo'"
                    class="item btn-item"
                    @click="resendInvitation(item)"
                >
                  {{ $lang.messages.sendInvitation }}
                </button>
              </div>
  
              <div>
                <button
                    v-if="coparentsProp && item.coparentType.toLowerCase() === 'duo' && (item.invitationStatus === 'INVITATION_SENT' || item.invitationStatus === 'INVITATION_EXPIRED')"
                    class="item btn-item"
                    @click="resendInvitation(item)"
                >
                  {{ $lang.messages.resendInvitation }}
                </button>
              </div>
              
              <div>
                <button
                    v-if="coparentsProp && item.coparentType.toLowerCase() === 'duo' && (item.invitationStatus === 'INVITATION_SENT' || item.invitationStatus === 'INVITATION_EXPIRED')"
                    class="item btn-item"
                    @click="cancelInvitation(item)"
                >
                  {{ $lang.messages.cancelInvitation }}
                </button>
              </div>
  
              <div>
                <button
                  v-if="coparentsProp && (item.coparentType.toLowerCase() === 'solo' || (item.coparentType.toLowerCase() === 'duo' && item.invitationStatus !== 'INVITATION_ACCEPTED'))"
                  class="item btn-item"
                  @click="editCoparent(item)"
                >
                  {{ $lang.messages.edit }}
                </button>
                <button v-if="childrenProp" class="item btn-item" @click="editChild(item)">
                  {{ $lang.messages.edit }}
                </button>
              </div>
  
              <div>
                <button
                  v-if="coparentsProp && item.invitationStatus !== 'INVITATION_ACCEPTED'"
                  class="item btn-item btn-delete"
                  @click="deleteModalOpen(item.guid, 'Co-Parent information', 'deleteCoparent')"
                >
                  {{ $lang.messages.deleteTable }}
                </button>
                <button
                  v-if="childrenProp && canChildBeDeleted(item.coparentGuid)"
                  class="item btn-item btn-delete"
                  @click="deleteModalOpen(item.guid, 'child information', 'deleteChild')"
                >
                  {{ $lang.messages.deleteTable }}
                </button>
              </div>
            </div>
          </span>
        </div>
      </section>
    </div>

    <!-- Delete Modal -->
    <delete-modal
      ref="deleteModalComponent"
      @deleteChild="deleteChild"
      @deleteCoparent="deleteCoparent">
    </delete-modal>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
import DeleteModal from "@/components/common/modals/DeleteModal";
import FPRegProgressTooltip from '@/components/common/FPRegistrationProgressTooltip';
import { dateFormat } from '@/mixins/dateFormat';

export default {
  name: "FPTableUserProfile",
  components: {
    DeleteModal,
    'f-p-registration-progress-tooltip': FPRegProgressTooltip,
  },
  mixins: [
    dateFormat
  ],
  props: {
    list: {
      type: Array,
      required: true,
      default: () => []
    },
    coparentsList: {
      type: Array,
      required: false,
      default: () => []
    },
    coparentsProp: {
      type: Boolean,
      required: false,
      default: () => false
    },
    childrenProp: {
      type: Boolean,
      required: false,
      default: () => false
    },
    mockData: {
      type: Boolean,
      required: false,
      default: () => false
    }
  },
  data() {
    return {
      actions: false,
      actionsRowId: 0
    }
  },
  computed: {
    ...mapGetters([
      'coparentAdded',
      'childAdded'
    ])
  },
  mounted() {
    this.onClickOutside();
  },
  methods: {
    onClickOutside() {
      let _this = this;
      document.addEventListener('click', function(e) {
        let dropdown = document.querySelector('#actions-ico');
        let clickedElement = e.target;

        if (clickedElement.className.indexOf('item') !== 0) {
          if (clickedElement.className.indexOf('actions-ico') === -1 && clickedElement !== dropdown) {
            _this.actions = false;
          }
        }
      });
    },
    toggleActions(guid) {
      this.actions = !this.actions;
      this.actionsRowId = guid;
    },
    deleteCoparent(guid) {
      this.$emit("deleteCoparent", guid)
    },
    deleteChild(guid) {
      this.$emit("deleteChild", guid)
    },
    editCoparent(item) {
      this.$emit("editCoparent", item)
    },
    editChild(item) {
      this.$emit("editChild", item)
    },
    resendInvitation(item) {
      this.$emit("resendInvitation", item)
    },
    cancelInvitation(item) {
      this.$emit("cancelInvitation", item)
    },
    deleteModalOpen(guid, type, typeOfDeletion) {
      this.$refs.deleteModalComponent.show(guid, type, typeOfDeletion);
    },
    canChildBeDeleted(coparentGuid) {
      const coparent =  this.coparentsList.find(item => item.guid === coparentGuid);
      return coparent.invitationStatus !== 'INVITATION_ACCEPTED';
    }
  }
};
</script>

